import { useTranslation } from "react-i18next";

import { Arrange, Button, Typography } from "@aviary";
import { useBreakpoints } from "@shared/hooks";
import { useLocation, useNavigate } from "@shared/react-router-dom";
import { WellevateAuthWrapper } from "@unauthenticated/shared/components/WellevateAuthWrapper";
import { l } from "@unauthenticated/wellevateAuthorize/patients/locales/i18n";

import MigrationInEligiblePatietSvg from "./migrationInEligiblePatient.svg";

import * as styles from "./AuthorizeFailNotEligible.styles";

const AuthorizeFailNotEligible = () => {
  const { t } = useTranslation();
  const { search } = useLocation();
  const { tablet } = useBreakpoints();
  const navigate = useNavigate();
  const isMobile = tablet.lessThan;

  const queryParams = new URLSearchParams(search);
  const patientEmail = queryParams.get("email");

  const handleOnClick = () => navigate(-1);

  return (
    <WellevateAuthWrapper>
      <Arrange isVertical justify="center" isFullwidth css={styles.wrapper}>
        <MigrationInEligiblePatietSvg css={styles.svg} />
        <section css={styles.section}>
          <header css={styles.header}>
            <Typography type="h1" sizeOverride={isMobile ? "h4" : "h3"} isMarginless>
              {patientEmail}{" "}
              <span css={styles.subHeader}>{t(l.common.ineligibleMessage.header)}</span>
            </Typography>
          </header>
          <Typography>{t(l.common.ineligibleMessage.content1)}</Typography>
          <Typography>{t(l.common.ineligibleMessage.content2)}</Typography>
        </section>

        <Button isFullWidth={isMobile} onClick={handleOnClick}>
          {t(l.common.ineligibleMessage.button)}
        </Button>
      </Arrange>
    </WellevateAuthWrapper>
  );
};

export { AuthorizeFailNotEligible };
